"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class ContactModel extends _1.BaseModel {
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            companyId: 'AccountId',
            description: 'Description',
            firstName: 'FirstName',
            fullName: 'Name',
            lastName: 'LastName',
            ownerId: 'OwnerId',
            recordTypeId: 'RecordTypeId',
            title: 'Title'
        };
    }
    get phoneNumbersWithValues() {
        return [
            this.phone,
            this.mobilePhone,
            this.homePhone,
            this.otherPhone
        ].filter((phoneNumber) => {
            return phoneNumber.number;
        });
    }
    get emailsWithValues() {
        return [
            this.email,
            this.email2
        ].filter((email) => {
            return email.address;
        });
    }
    get position() {
        if (this.title && this.company && this.company.name) {
            return `${this.title} at ${this.company.name}`;
        }
        return this.title || this.company && this.company.name || '';
    }
    transformToSalesforce() {
        const sfContact = super.transformToSalesforce();
        sfContact.Email = this.email.address;
        sfContact.McLabs2__Email_2__c = this.email2.address;
        sfContact.Phone = this.phone.number;
        sfContact.MobilePhone = this.mobilePhone.number;
        sfContact.HomePhone = this.homePhone.number;
        sfContact.OtherPhone = this.otherPhone.number;
        sfContact.Fax = this.fax.number;
        sfContact.MailingStreet = this.address.street;
        sfContact.MailingCity = this.address.city;
        sfContact.MailingPostalCode = this.address.postalCode;
        sfContact.MailingState = this.address.state;
        sfContact.MailingCountry = this.address.country;
        // Salesforce doesn't allow updates on Name
        delete sfContact.Name;
        return sfContact;
    }
    transformFromSalesforce(sfContact) {
        super.transformFromSalesforce(sfContact);
        this.type = sfContact.RecordType ? sfContact.RecordType.Name : undefined;
        this.phone = new _1.PhoneNumberModel('Phone', sfContact.Phone);
        this.mobilePhone = new _1.PhoneNumberModel('Mobile Phone', sfContact.MobilePhone);
        this.homePhone = new _1.PhoneNumberModel('Home Phone', sfContact.HomePhone);
        this.otherPhone = new _1.PhoneNumberModel('Other Phone', sfContact.OtherPhone);
        this.fax = new _1.PhoneNumberModel('Fax', sfContact.Fax);
        this.email = new _1.EmailAddressModel('Email', sfContact.Email);
        this.email2 = new _1.EmailAddressModel('Email2', sfContact.McLabs2__Email_2__c);
        this.address = new _1.AddressModel('Mailing Address', sfContact.MailingAddress);
    }
    transformFromJson(json) {
        Object.assign(this, json);
        this.phone = new _1.PhoneNumberModel('Phone', json.phone);
        this.mobilePhone = new _1.PhoneNumberModel('Mobile Phone', json.mobilePhone);
        this.homePhone = new _1.PhoneNumberModel('Home Phone', json.homePhone);
        this.otherPhone = new _1.PhoneNumberModel('Other Phone', json.otherPhone);
        this.fax = new _1.PhoneNumberModel('Fax', json.fax);
        this.email = new _1.EmailAddressModel('Email', json.email);
        this.email2 = new _1.EmailAddressModel('Email2', json.email2);
        this.address = new _1.AddressModel('Mailing Address', json.address || {
            street: json.street,
            city: json.city,
            state: json.state,
            postalCode: json.postalCode,
            country: json.country
        });
    }
}
exports.ContactModel = ContactModel;
//# sourceMappingURL=contact.model.js.map